import http from '../plugins/axios';
export async function getLogin(payload) {
  const response = await http.post('login', payload);
  return response.data;
}

export async function getLogout() {
  const response = await http.post('logout')
  return response.data

}

export async function getChangePassword(old_password, new_password, comfirm_password) {
  let input = {
    old_password: old_password,
    password_confirmation: comfirm_password,
    password: new_password
  }
  const response = await http.post('change-password', input)
  return response;
}

export async function getUserDetail() {
  const response = await http.post('account-detail');
  return response.data;
}

export async function getManagers(payload) {
  return await http.get(`/cashier/get-admins?type_id=${payload}`);
}


